module.exports.LANGUAGES = {
  EN: 'en',
  AR: 'ar',
}
module.exports.TYPENAME = '__typename'
module.exports.BLOG_WRITTEN_BY_TEXT = 'Written by'
module.exports.SLASH_HEIGHT = 210
module.exports.ContentType = {
  videoMp4: 'video/mp4',
}
module.exports.BLOG_MINUTE_DURATION_EN = 'min read'
module.exports.BLOG_MINUTE_DURATION_AR = 'دقيقة مشاهدة'
module.exports.BLOG_SLIDER_HEADING_EN = 'More like this'
module.exports.BLOG_SLIDER_HEADING_AR = 'المزيد من هذا القبيل'
module.exports.ROUTES = {
  HOME: {
    to: '/',
    key: 'What we do',
  },
  ABOUT: {
    to: '/aboutUs',
    key: 'About us',
  },
  FAQS: {
    to: '/faqs',
    key: 'faqs',
  },
  PRICING: {
    to: '/pricing',
    key: 'pricing',
  },
  CONTACT: {
    to: '/contactUs',
    key: 'Contact us',
  },
  TANDC: {
    to: '/termsAndConditions',
    key: 'Terms & Conditions',
  },
  PRIVACY: {
    to: '/privacyPolicy',
    key: 'Privacy Policy',
  },
  AUTO_LEASING: {
    to: '/auto-leasing',
    key: 'Auto Leasing',
  },
}

module.exports.LEASING_DETAIL_SUBROUTES = {
  AFTER_SALES: {
    to: `${module.exports.ROUTES.AUTO_LEASING.to}/after-sales-services`,
    key: 'After Sales Services',
  },
  FIFTY_FIFTY: {
    to: `${module.exports.ROUTES.AUTO_LEASING.to}/fifty-fifty`,
    key: '50/50',
  },
  FLEXI: {
    to: `${module.exports.ROUTES.AUTO_LEASING.to}/flexi-program`,
    key: 'Flexi Program',
  },
  MONTHLY: {
    to: `${module.exports.ROUTES.AUTO_LEASING.to}/monthly-installments`,
    key: 'Monthly Installments',
  },
  MOTORCYCLE: {
    to: `${module.exports.ROUTES.AUTO_LEASING.to}/motorcycle`,
    key: 'Motorcycle Leasing',
  },
  SALES_LEASE_BACK: {
    to: `${module.exports.ROUTES.AUTO_LEASING.to}/sales-lease-back`,
    key: 'Sales & Lease Back',
  },
  SIGN_DRIVE: {
    to: `${module.exports.ROUTES.AUTO_LEASING.to}/sign-and-drive`,
    key: 'Sign & Drive',
  },
  TAKHAYER: {
    to: `${module.exports.ROUTES.AUTO_LEASING.to}/takhayer`,
    key: 'Takhayer',
  },
}

module.exports.METADATA = {
  title: 'JB',
  titleAr: 'جيبي',
  description:
    'نوفر لك حلول مالية متعددة بكل سهولة، تسهّل حياتك وتبسّط عليك تخطيطك المالي، وتوصل لجيبك بأسرع وقت.',
  author: '',
  siteUrl: {
    development: 'localhost:8000',
    production: 'https://j-b.com.sa/',
  },
}

module.exports.GOOGLE_LINKS = {
  privacyPolicy: 'https://policies.google.com/privacy',
  termsOfService: 'https://policies.google.com/terms',
}
